import { render, staticRenderFns } from "./DoctorWithBookimed.vue?vue&type=template&id=0a080d18&"
import script from "./DoctorWithBookimed.vue?vue&type=script&lang=js&"
export * from "./DoctorWithBookimed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports